<template>
    <div class="mainPage">
        <div style="height:92vh;overflow-y:scroll;">
         <div class="topBox"><i class="el-icon-back mr10 f20" @click="goBack"></i>批量制券</div>
           <div class="mainBox">
              <div class="specialReminder"> 
                 <!-- <img src="@/assets/images/remind.png" class="remindIcon" />  -->
                 <i class="el-icon-warning remindIcon"></i>
                 <div class="ml20">批量制券后系统会自动生成随机数字的优惠券码，用于券码绑定到会员账户、核销。</div>
              </div>
            <el-row>
                 <el-col :span="24">
                        <div class="modelTitel">优惠券信息</div>
                 </el-col>
                 <el-col class="infoBox">
                      <el-form label-width="170px">
                          <el-col :span="24" class="h35">
                                <el-form-item label="优惠券名称/ID:">
                                      <span class="f15">无门槛立减10元券/3939494</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="有效期:">
                                      <span class="f15">激活后当天生效，有效期 90 天</span>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="可使用门店:">
                                      <span class="f15">满品客大饭堂（习友路店）</span>
                                </el-form-item>
                          </el-col>
                      </el-form>
                 </el-col>
             </el-row>
             <el-row>
                 <el-col :span="24" class="flex itemsCenter">
                        <div class="modelTitel">制券信息</div>
                         <span class="useIllustrate" @click="useDialogdOpen">使用说明</span>
                 </el-col>
                 <el-col class="infoBox">
                      <el-form label-width="170px" :model="createForm" :rules="createRules" ref="createForm" >
                          <el-col :span="12" class="h35">
                                <el-form-item label="优惠券名称/ID:" prop="createCount">
                                      <el-input v-model="createForm.createCount" placeholder="请输入制券张数"></el-input>
                                </el-form-item>
                          </el-col>
                          <el-col :span="24" class="h35">
                                <el-form-item label="指定发券门店:">
                                      <span class="f15">满品客大饭堂（习友路店）</span>
                                </el-form-item>
                          </el-col>
                      </el-form>
                 </el-col>
             </el-row>
           </div>
          <div class="footerBox"> 
            <div>
                 <el-button type="">取消</el-button>
                 <el-button type="primary">保存</el-button>
            </div>
        </div>
        </div>
      <!-- 使用说明弹框 -->
      <el-dialog
        title="使用说明"
        :visible.sync="dialogVisible"
        width="800px">
        <span>优惠券兑换场景</span>
         <div class="imagesBox">
            <img src="@/assets/images/use1.png" alt="" class="imageOne">
            <img src="@/assets/images/use2.jpg" alt="" class="imageTwo">
         </div>
      </el-dialog>

    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogVisible:false,
            createForm:{},
           createRules:{
              createCount:[{ required: true, message: '请输入制券张数', trigger: 'blur' }]
           },
        }
    },
    methods:{
        //使用弹框
        useDialogdOpen(){
           this.dialogVisible = true
        },
       //返回
        goBack (){
            this.$router.push({path:'/banchCreatedCoupon'})
        },
    }
}
</script>

<style lang="less" scoped>
.mainPage {
  width: 99%;
//   height: 90vh;
  /* padding: 30px; */
  background: #fff;
  overflow-y: scroll;
}
.topBox{
    /* width: 100%; */
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #ddd;
    font-size: 18px;
}
.f20{
    font-size: 20px;
    cursor: pointer;
}
.mainBox{
    /* width: 100%; */
    height: 73vh;
    background:#fff;
    padding: 30px;
    // overflow-y: scroll;
}
.footerBox{
    height: 40px;
    padding:10px 30px;
    background: #fff;
    border-top: 1px solid #ddd;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
/deep/ .el-button--primary {
  background-color: rgb(245, 154, 35);
  border-color: rgb(245, 154, 35);
}
/deep/ .el-button:focus,
.el-button:hover {
  color: rgb(245, 154, 35);
  border-color: #f5dab1;
  background-color: #fdf6ec;
}
.specialReminder{
    padding: 0 30px;
    background: #fff6e8;
    border: 1px solid #ffd99f;
    border-radius: 7px;
    height: 40px;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    font-size: 15px;
    color: #606266;
}
.remindIcon{
//    width: 18px;
//    height: 18px;
 color: #f90;
 font-size: 17px;
}
.modelTitel{
    font-size: 17px;
    position: relative;
    padding-left: 15px;
}
.modelTitel::before{
    content: " ";
    width: 4px;
    height: 16px;
    background: rgb(245,154,35);
    position: absolute;
    left: 0;
    bottom: 3px;
} 
.h35{
    height: 40px;
} 
.infoBox{
    font-size: 15px;
    color: #606266;
    margin-top: 20px;
}
/deep/ .el-form-item__label{
    font-size: 15px;
}
.f15{
    font-size: 15px;
}
.useIllustrate{
    margin-left: 16px;
    color: #fe8c00;
    font-size: 15px;
    line-height: 14px;
    font-weight: 500;
    cursor: pointer;
}
.itemsCenter{
    align-items: center;
}
.imagesBox{
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}
.imageOne{
    width: 274px;
    height: 386px;
}
.imageTwo{
    width: 456px;
    height: 386px;  
}
/deep/ .el-dialog__header{
    border-bottom: 1px solid #e8e8e8;
}
</style>